import React, {Fragment, useState} from 'react';

import {SidebarSectionHeader} from 'app/general/structures/DocSidebarPagePanels';
import StateButton from 'app/general/widgets/StateButton';
import {SignoffInfiniteListFetcher} from 'app/signoffs/datafetchers';
import {gt} from 'app/utils/i18n';

import {SignoffDocumentHistoryItem} from './SignoffDocumentHistoryItem';

import type {BaseDocumentContentType} from 'sweet-types';

type Props = {
  objectId: number;
  contentType: BaseDocumentContentType;
};

export const SignoffDocumentHistory = ({
  objectId,
  contentType,
}: Props): JSX.Element => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(true);
  return (
    <Fragment>
      <SidebarSectionHeader
        title={gt('history')}
        actionButton={
          <button
            className="btn btn-sm btn-link p-0"
            onClick={() => setIsCollapsed(!isCollapsed)}
          >
            {isCollapsed ? gt('Show') : gt('Hide')}{' '}
            <i className={`fas fa-chevron-${isCollapsed ? 'down' : 'up'}`} />
          </button>
        }
      />
      {!isCollapsed ? (
        <SignoffInfiniteListFetcher
          fetchParams={{
            object_id: objectId,
            content_type: contentType,
          }}
        >
          {({allResults, loading, loadNext, hasNext, loadingLast}) => (
            <ul className="list-unstyled">
              {!loading &&
              allResults.length === 0 ? null : allResults.length !== 0 ? (
                <ul
                  className={`list-unstyled ${
                    isCollapsed ? 'collapse' : 'collapse.show'
                  }`}
                >
                  {!isCollapsed &&
                    allResults.map((item) => (
                      <li key={item.id}>
                        <SignoffDocumentHistoryItem signoff={item} />
                      </li>
                    ))}
                </ul>
              ) : null}

              {!loading && (hasNext || loadingLast) ? (
                <li>
                  <div className="text-center my-2 mx-4">
                    <StateButton
                      isIdle={!loadingLast}
                      className="btn btn-secondary btn-sm btn-block"
                      busyText={gt('Loading...')}
                      onClick={loadNext}
                    >
                      {gt('Load more')}
                    </StateButton>
                  </div>
                </li>
              ) : null}
            </ul>
          )}
        </SignoffInfiniteListFetcher>
      ) : null}
    </Fragment>
  );
};
